var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switcher",class:[ 'switcher_size-' + _vm.size, 'switcher_' + _vm.type, _vm.state ? 'switcher_active' : '' ]},[_c('span',[_vm._v(_vm._s(_vm.leftSign))]),_c('div',{staticClass:"switcher__control",on:{"click":_vm.onClick}},[_c('div',{staticClass:"switcher__mark"})]),_c('span',[_vm._v(_vm._s(_vm.rightSign))])])
}
var staticRenderFns = []

export { render, staticRenderFns }